import { Box, Typography } from '@mui/material';
import { FC } from 'react';

type Props = {
  companyName: string;
  email?: string;
};

export const ProfileData: FC<Props> = ({ email, companyName }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        paddingX: 3,
        paddingY: 2.5
      }}
    >
      <Box>
        <Typography className="font-bold text-lg pb-1">{companyName}</Typography>
        <Typography variant="body2">{email}</Typography>
      </Box>
    </Box>
  );
};
